import React from 'react';
import App from './App';
import './App.css';

function MainApp() {
  return <App />;
}

export default MainApp; 